import React from 'react';
import hand_icon from '../Assets/hand_icon.png'
import arrow_icon from '../Assets/arrow.png'
import hero_image from '../Assets/hero_image.png'
import './Hero.css'


const Hero = () => {
  return (
    <div className="Hero">
       <div className="hero_left">

            <h2>NEW ARRIVALS ONLY</h2>
                <div className="hand_icon">
                    <p>new</p>
                    <img src={hand_icon} alt="" />  
                </div>
                <p>collections</p>
                <p>for everyone </p>
                 <div className='hero-latest-btn'>
                        <div>latest collections</div>
                        <img src={arrow_icon} alt="" />
                    </div >
            
       </div>
       <div className="hero_right">
        <img src={hero_image} alt="" />
       </div>
    </div>
  );
};

export default Hero;